// extracted by mini-css-extract-plugin
export default {"placeholder":"gallery-item-placeholder_placeholder__s+i0c"};